import { connect } from 'react-redux';
import Login from './Login';

function mapStateToProps({ config }) {
  return {
    consumerHost: config.consumerHost,
    identityHost: config.identityHost,
  };
}

export default connect(mapStateToProps)(Login);
